export const getDate7DaysAgo = (date = new Date()) => {
  const taskDate = new Date(date);
  const today = new Date();
  const difference = today.getTime() - taskDate.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
};
